import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [themeColor, setThemeColor] = useState("#ffffff");

    useEffect(() => {
        const savedColor = localStorage.getItem("themeColor") || "#ffffff";
        setThemeColor(savedColor);
        setCSSVariables(savedColor);
    }, []);

    const setCSSVariables = (color) => {
        let textColor = "#000000";
        let bgColor = "#ffffff";
        let accent = "#007bff";

        if (color === "#1a1a1a") {
            textColor = "#ffffff";
            bgColor = "#1a1a1a";
            accent = "#66ccff";
        } else if (color === "#E68F5A") {
            textColor = "#1a1a1a";
            accent = "#E68F5A";
        } else if (color === "#D0E8FF") {
            textColor = "#1a1a1a";
            accent = "#0099cc";
        }

        document.documentElement.style.setProperty('--bg-color', bgColor);
        document.documentElement.style.setProperty('--text-color', textColor);
        document.documentElement.style.setProperty('--accent-color', accent);
    };

    const changeTheme = (color) => {
        setThemeColor(color);
        localStorage.setItem("themeColor", color);
        setCSSVariables(color);
    };

    return (
        <ThemeContext.Provider value={{ themeColor, changeTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);